import React from "react";
import classNames from "classnames";
import styles from "./horizontal-layout-view.module.scss";
import SafeImage from "@components/common/SafeImage";

type HorizontalLayoutViewCompProps = {
  header: React.ReactElement;
  imageProps: {
    src: string;
    alt: string;
    width: number;
    height: number;
  };
  children: React.ReactElement | React.ReactElement[];
  className?: string;
};

const HorizontalLayoutViewComp: React.FC<HorizontalLayoutViewCompProps> = (props) => {
  const { header, imageProps, children, className } = props,
    classes = classNames(styles["horizontal-layout-view"], className, "clearfix");

  return (
    <div className={classes}>
      <div className={classNames(styles["img-container"], styles["float"], styles["desk-only"])}>
        <SafeImage src={imageProps.src} alt={imageProps.alt} width={imageProps.width} height={imageProps.height} />
      </div>
      <div className={classNames(styles["content"])}>
        {header}
        <div className={classNames(styles["img-container"], styles["mobile-only"])}>
          <SafeImage src={imageProps.src} alt={imageProps.alt} width={imageProps.width} height={imageProps.height} />
        </div>
        {children}
      </div>
    </div>
  );
};

export default HorizontalLayoutViewComp;
